import { Component, Input, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AlertsService } from '../../../../services/alerts/alerts.service';
import { SelectOptionComponent } from './select-option.component';

@Component({
  selector: 'app-notify-option',
  imports: [SelectOptionComponent],
  template: `
    <app-select-option
      label="Send notifications for"
      [control]="control"
      [items]="alerts.notifyItems"
      [multiple]="false"
      [filter]="false"
      [virtualScroll]="false"
      selectLabel=""
    />
  `,
  styles: ``,
})
export class NotifyOptionComponent {
  alerts = inject(AlertsService);

  @Input()
  control: FormControl<number>;
}
